import { memo } from 'react';

import { useAnimatedOnboardingUploadVisibility } from '~/components/WorkspaceOnboardingForm/hooks/useAnimatedOnboardingUploadVisibility';
import { WorkspaceAnimatedOnboardingUploadPrompt } from '~/components/WorkspaceOnboardingForm/WorkspaceAnimatedOnboardingUploadPrompt';
import { WorkspaceOnboardingUploadPrompt } from '~/components/WorkspaceOnboardingForm/WorkspaceOnboardingUploadPrompt';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const WorkspaceOnboardingUploadPromptGate = memo(() => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { showAnimatedWorkspace, showPendingAnimatedUploadStep } = useAnimatedOnboardingUploadVisibility(
    currentWorkspace?.id,
  );

  if (showPendingAnimatedUploadStep) {
    return <WorkspaceAnimatedOnboardingUploadPrompt />;
  }

  if (showAnimatedWorkspace) {
    return null;
  }

  return <WorkspaceOnboardingUploadPrompt />;
});

WorkspaceOnboardingUploadPromptGate.displayName = 'WorkspaceOnboardingUploadPromptGate';
